import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import usePageMeta from "../../utils/usePageMeta";

const Payment = () => {
  usePageMeta({
    title: "Payment | MD Wedding Props",
    description: "Complete your booking payment securely for wedding props.",
    keywords: "wedding props payment, secure checkout",
  });

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Payment gateway" />
      <div className="pb-10">
        <p>Payment gateway only applicable for Production build.</p>
        <Link to="/">
          <button className="w-52 h-10 bg-primeColor text-white text-lg mt-4 hover:bg-black duration-300">
            Explore More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Payment;
